import dayjs from 'dayjs';

export const removeTimezone = (date: string) => {
  const day = dayjs(date);

  return day.subtract(day.utcOffset(), 'minutes').toISOString();
};
